// @flow
export const cookieOptions = {
    encoding: 'none',
    ttl: 1000 * 60 * 60 * 24 * 30,
    path: '/',
    isSecure: false,
    isHttpOnly: false
};

export const HAS_DOCUMENT_COOKIE =
    typeof document === 'object' && typeof document.cookie === 'string';

export type HapiCookieState = {
    name: string,
    data: string,
    options?: any
};

type CookieName =
    | 'ha-state-prst'
    | 'ha-trip-prst'
    | 'eu-site'
    | 'ha-children-age-prst'
    | 'ha_covid_banner_disabled';

type WriteCookieOptions = {
    saveAsJson?: boolean,
    shouldUrlEncode?: boolean,
    daysToExpire?: number
};

const writeCookie = (
    name: CookieName,
    value: mixed,
    options?: WriteCookieOptions = {}
) => {
    if (!HAS_DOCUMENT_COOKIE) {
        return;
    }
    let mergedOptions = {
        saveAsJson: true,
        shouldUrlEncode: true,
        daysToExpire: 30,
        ...options
    };
    let cookieValue = value;
    if (mergedOptions.saveAsJson) cookieValue = JSON.stringify(cookieValue);
    if (mergedOptions.shouldUrlEncode)
        cookieValue = encodeURIComponent(String(cookieValue));

    const expireTime = new Date();
    expireTime.setTime(
        expireTime.getTime() + mergedOptions.daysToExpire * 24 * 60 * 60 * 1000
    );
    const cookie = [
        name,
        '=',
        cookieValue,
        ';expires=',
        expireTime.toUTCString(),
        '; path=/;'
    ].join('');

    document.cookie = cookie;
};

const matchCookie = (
    name: CookieName,
    source: string,
    /* istanbul ignore next */
    isJSON?: ?boolean = true
): Object => {
    const regexValue = '=([^;]+)';
    let regexArray = source.match(new RegExp(name + regexValue));
    let result;
    if (regexArray && regexArray.length > 0) {
        result = decodeURIComponent(regexArray[1]);
        if (isJSON) result = JSON.parse(result);
    } else {
        result = {};
    }
    return result;
};

const readCookie = (
    name: CookieName,
    cookieSource?: ?string,
    isJSON?: ?boolean = true
): Object => {
    if (!cookieSource) {
        cookieSource = HAS_DOCUMENT_COOKIE ? document.cookie : '';
    }
    let result;
    try {
        result = matchCookie(name, cookieSource, isJSON);
    } catch (err) {
        result = {};
    }
    return result;
};

function deleteCookie(name: CookieName) {
    if (!HAS_DOCUMENT_COOKIE) {
        return;
    }
    document.cookie = [
        name,
        '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/'
    ].join('');
}

export default {writeCookie, deleteCookie, readCookie};
export {writeCookie, readCookie, deleteCookie};
